import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left-small",
  "use": "arrow-left-small-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\" id=\"arrow-left-small\">\n  <path fill-rule=\"evenodd\" d=\"M231.985,154L238,148.987v10.025Z\" transform=\"translate(-232 -149)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-left-small.svg
// module id = null
// module chunks = 